import { createContext } from 'react';

export default createContext(new Map());
